import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import Link from "next/link";
import { Svg } from "../../../../../Svg";
import { NodeWithSvg } from "../../../NodeWithSvg";
import { useButton } from "../../button.hook";
import * as S from "./buttonA.style";
export var A = function(_param) {
    var as = _param.as, children = _param.children, disableAppMobileOpenInBrowser = _param.disableAppMobileOpenInBrowser, disabled = _param.disabled, _href = _param.href, locale = _param.locale, _onClick = _param.onClick, _onMouseEnter = _param.onMouseEnter, _onMouseLeave = _param.onMouseLeave, onTouchStart = _param.onTouchStart, prefetch = _param.prefetch, replace = _param.replace, scroll = _param.scroll, shallow = _param.shallow, _model = _param.model, model = _model === void 0 ? "regular" : _model, size = _param.size, soft = _param.soft, svg = _param.svg, _svgPosition = _param.svgPosition, svgPosition = _svgPosition === void 0 ? "right" : _svgPosition, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, rest = _object_without_properties(_param, [
        "as",
        "children",
        "disableAppMobileOpenInBrowser",
        "disabled",
        "href",
        "locale",
        "onClick",
        "onMouseEnter",
        "onMouseLeave",
        "onTouchStart",
        "prefetch",
        "replace",
        "scroll",
        "shallow",
        "model",
        "size",
        "soft",
        "svg",
        "svgPosition",
        "variant"
    ]);
    var ref = useButton({
        _href: _href,
        _onClick: _onClick,
        _onMouseEnter: _onMouseEnter,
        _onMouseLeave: _onMouseLeave,
        disableAppMobileOpenInBrowser: disableAppMobileOpenInBrowser,
        disabled: disabled,
        size: size,
        variant: variant
    }), color = ref.color, height = ref.height, href = ref.href, onClick = ref.onClick, onMouseEnter = ref.onMouseEnter, onMouseLeave = ref.onMouseLeave;
    return /*#__PURE__*/ _jsx(Link, {
        as: as,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        href: href,
        locale: locale,
        passHref: !disabled,
        prefetch: prefetch,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        soft: soft,
        legacyBehavior: true,
        children: /*#__PURE__*/ _jsx(S.A, _object_spread_props(_object_spread({}, rest), {
            disabled: disabled,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onTouchStart: onTouchStart,
            model: model,
            size: size,
            variant: variant,
            children: model === "regular" ? /*#__PURE__*/ _jsx(NodeWithSvg, {
                color: color,
                height: height,
                svg: svg,
                svgPosition: svgPosition,
                children: children
            }) : /*#__PURE__*/ _jsx(Svg, {
                name: svg || "plusBtn",
                color: color,
                height: height
            })
        }))
    });
};
